import api from '@/api'

export const SET_ALL_PLATFORMS = 'SET_ALL_PLATFORMS'
const state = {
  allPlatforms: [],
}

const mutations = {
  [SET_ALL_PLATFORMS](state, payload) {
    state.allPlatforms = payload
  },
}

const actions = {
  // 获取平台配置列表
  async getPlatformList({ commit, state }, payload) {
    const { data } = await api.deployApi.getPlatformList(payload)
    return data
  },
  async getAllPlatformsList({ commit, state }, payload) {
    const { data } = await api.deployApi.queryAllByCondition()
    commit('SET_ALL_PLATFORMS', data)
  },
  // 新增平台配置
  async addPlatform({ state }, payload) {
    const data = await api.deployApi.addPlatform(payload)
    return data
  },
  // 编辑平台配置
  async dealPlatform({ state }, payload) {
    const data = await api.deployApi.editPlatform(payload)
    return data
  },
  // 删除平台配置
  async deletePlatform({ state }, payload) {
    const data = await api.deployApi.deletePlatform(payload)
    return data
  },
  // 检查导入平台配置数据
  async checkImportPlatformConfigData({ state }, payload) {
    const data = await api.deployApi.checkImportPlatformConfigData(payload)
    return data
  },
  // 添加平台配置
  async addPlatformConfig({ state }, payload) {
    const data = await api.deployApi.addPlatformConfig(payload)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
